import { ServicePaymentPmupStore } from './service-payment-pmup.store';
import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NumberInputComponent } from '../../../kit/input/text-input/number-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { SwitchInputComponent } from '../../../kit/input/switch-input/switch-input.component';

@Component({
    selector: 'app-service-payment-pmup',
    templateUrl: './service-payment-pmup.component.html',
    styleUrl: './service-payment-pmup.component.scss',
    standalone: true,
    providers: [ServicePaymentPmupStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NumberInputComponent,
        TranslatePipe,
        Tooltip,
        SwitchInputComponent,
    ],
})
export class ServicePaymentPmupComponent {

    public readonly store = inject(ServicePaymentPmupStore);

    public form = input<FormGroup>();
    public paymentId = input<number | null>(null);
    public formChange = input<any>();

    protected readonly prefix = 'service.payments.pmup.';

    constructor() {
        effect(() => {
            const value = this.formChange();
            if (!value || !value.payment || !value.pumRef || value.direct) return;

            this.form()?.patchValue({
                pmupRef: Math.round(value.payment / value.pumRef),
            }, { emitEvent: false });
        });
    }
}
